import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import {commitMutation, graphql} from 'react-relay';
import {createRangeBulkAddUpdater} from '../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation ImportPipedriveOrganizationsMutation($input: ImportPipedriveOrganizationsInput!) {
		importPipedriveOrganizations(input: $input) {
			clients {
				cursor
				node {
					id
					name
					notes
					logoId
					logoDefaultId
					projectCount
					economicCustomerId
					quickbooksCustomerId
					xeroContactId
					salesforceAccountId
					hubspotCompanyId
					pipedriveOrganizationId
					sageIntacctCustomerId
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Bulk Clients Created');
	const cleanedInput = omit(input, ['companyId']);

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		updater: createRangeBulkAddUpdater(input.companyId, 'importPipedriveOrganizations', 'clients', 'Company_clients'),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
